import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { ProductStatusCell } from "@/components/table"
import type { Product } from "@/graphql/codegen/graphql"

interface GoodsReceiptProductLayoutProps {
  product: Product
  children: React.ReactNode
  "data-testid"?: string
}

export const GoodsReceiptProductLayout: FC<GoodsReceiptProductLayoutProps> = ({
  product,
  children,
  "data-testid": testId = "product-layout",
}) => {
  return (
    <Box className='flex items-center gap-4 rounded-md border bg-primary-200 p-4' data-testid={testId}>
      <Box className='mr-auto flex items-center gap-x-8'>
        <ProductStatusCell product={product} />
        <Typography component='div' variant='body2' className='text-gray-700'>
          <Box component='span' className='font-bold' data-testid='company-description'>
            {product.companyProductDescription}
          </Box>
          <br />
          <span data-testid='vendor-description'>{product.vendorDescription}</span>
        </Typography>
      </Box>
      {children}
    </Box>
  )
}
